import React, { useEffect, useRef, useState } from "react";
import style from "./otp.module.css";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getOTP, getPhone } from "../../store/login/action";
import { toEnglishNumber } from "../../helpers/converting";
import useTimer, { TimerProps } from "../../hooks/useTimer";
import { LoginSteps } from "../../types/config";
import { loginAction } from "../../store/login/slice";
import { configAction } from "../../store/config/slice";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import Button from "../button/Button";
import { useWebEngageTaraLoginDone } from "../../hooks/webengage";
let currentOTPIndex: number = 0;
const OTP_NUMBER = 5;
const OneTeimePassword = () => {
  const { trackWebEngageTaraLoginDone } = useWebEngageTaraLoginDone();
  const dispatch = useAppDispatch();
  const sendDataToGTM = useGTMDispatch();
  const [isTimer, setIsTimer] = useState(true);
  const [otp, setOtp] = useState<string[]>(new Array(OTP_NUMBER).fill(""));
  const [activeOTPindex, setActiveOTPIndex] = useState<number>(0);

  const inputRef = useRef<HTMLInputElement>(null);
  const credentioalInput = useRef<HTMLInputElement>(null);

  const { userPhone, request, auth } = useAppSelector((state) => state.login);

  /**
   * inputs OTP
   */
  // paste vlaue validate
  const checkPasteValue = function (value: string) {
    const pastedOnKeboard = value.trim().slice(0, OTP_NUMBER).split("");
    setOtp(pastedOnKeboard);
    const Token = toEnglishNumber(pastedOnKeboard.join(""));
    setActiveOTPIndex(Token.length - 1);
    dispatch(getOTP(userPhone, Token));
  };
  const handleOtp = function (e: React.ChangeEvent<HTMLInputElement>) {
    const { value } = e.target;

    //handle pasete code
    if (value.length >= OTP_NUMBER && !isNaN(value as any)) {
      return checkPasteValue(value);
    }
    const newOtp: string[] = [...otp];
    newOtp[currentOTPIndex] = value.substring(value.length - 1);
    if (!value) setActiveOTPIndex(currentOTPIndex - 1);
    else setActiveOTPIndex(currentOTPIndex + 1);
    setOtp(newOtp);
    const Token = toEnglishNumber(newOtp.join(""));
    if (Token.length === OTP_NUMBER) {
      dispatch(getOTP(userPhone, Token)).then((data) => {
        if (data?.data.new_user) {
          // sendDataToGTM({ event: "BaniShans1403_newuser" });
        } else {
          // sendDataToGTM({ event: "BaniShans1403_totaluser" });
        }
        if (data?.status_code === 200) {
          trackWebEngageTaraLoginDone();
        }
      });
    }
  };
  const handleOnkeyDown = function (
    { key }: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) {
    currentOTPIndex = index;
    if (key === "Backspace") setActiveOTPIndex(currentOTPIndex - 1);
  };

  useEffect(() => {
    inputRef.current?.focus();
    // dispatch(loginAction.setAuthError(null));
  }, [activeOTPindex]);
  /**
   * timer
   */
  const { seconds, formattedTime, startTimer, resetTimer }: TimerProps =
    useTimer(request.data?.data.ttl);
  useEffect(() => {
    if (seconds <= 0) {
      resetTimer();
      setIsTimer(false);
      dispatch(loginAction.setAuthError(null));
    }
  }, [seconds]);
  const getOtpcredintial = function () {
    if ("OTPCredential" in window) {
      if (!credentioalInput.current) return;
      const controller = new AbortController();
      const credentioanTransport = {
        otp: { transport: ["sms"] },
        signal: controller.signal,
      };
      navigator.credentials
        .get(credentioanTransport)
        .then((otp: any) => {
          if (credentioalInput.current) {
            credentioalInput.current.value = otp.code;
            checkPasteValue(credentioalInput.current.value!);
          }
        })
        .catch((error: any) => {
          console.log("crd", error);
        });
    }
  };
  useEffect(() => {
    startTimer();
    getOtpcredintial();
  }, []);
  /**
   * send again code
   */
  const handleTryAgainCode = function (type: string) {
    if (type === "sms") dispatch(getPhone(userPhone, "sms"));
    if (type === "call") dispatch(getPhone(userPhone, "call"));
    dispatch(loginAction.setAuthError(null));
    startTimer();
    setIsTimer(true);
  };
  const handleSendOtp = function () {};
  return (
    <>
      <div className={`${style["otp-container"]}  flex-center flex-col`}>
        <div className={style["otp-inner"]}>
          <div className={style["top-box"]}>
            <div className={style.title}>
              <span>کد تایید را وارد کنید</span>
            </div>
            <label htmlFor="">
              <span>{`کد تایید ۵ رقمی ارسالی به ${userPhone} را وارد کنید`}</span>
            </label>
            <div className={style["otp-inputs-box"]}>
              {otp.map((_, index) => (
                <input
                  ref={index === activeOTPindex ? inputRef : null}
                  type="tel"
                  autoComplete="off"
                  key={index}
                  onChange={handleOtp}
                  value={otp[index]}
                  onKeyDown={(e) => handleOnkeyDown(e, index)}
                  onFocus={() => dispatch(loginAction.setAuthError(null))}
                  placeholder="-"
                />
              ))}
            </div>
            <input
              className={style.credentioal}
              type="text"
              ref={credentioalInput}
            />
            {!!auth.error && (
              <div className={style.error}>
                <span>{auth.error}</span>
              </div>
            )}
            <div className={style["call-box"]}>
              {isTimer && (
                <div className={style.timer}>
                  <span className={style["timer-text"]}>
                    کد را دریافت نکردم
                  </span>
                  <span className={style["timer-counter"]}>
                    ({formattedTime})
                  </span>
                </div>
              )}
              {!isTimer && (
                <div className={style.try}>
                  <div className={style["try-box"]}>
                    <button
                      className={style["try-sms"]}
                      onClick={() => handleTryAgainCode("sms")}
                    >
                      کد را دریافت نکردم{" "}
                    </button>
                    {request.data?.data.otp_call_enable && (
                      <button
                        className={style["try-call"]}
                        onClick={() => handleTryAgainCode("call")}
                      >
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/icon/call.svg`}
                          alt=""
                        />
                      </button>
                    )}
                  </div>
                </div>
              )}
              <div className={style.edit}>
                <button
                  onClick={() =>
                    dispatch(configAction.setLoginStep(LoginSteps.PHONE))
                  }
                >
                  تغییر شماره
                </button>
              </div>
            </div>
          </div>
          <div className={style["down-box"]}>
            <div className={style["down-box-inner"]}>
              <Button
                onclick={handleSendOtp}
                text="ورود"
                className={`${style.submit}`}
                loading={auth.loading}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OneTeimePassword;
